import { render, staticRenderFns } from "./PortfolioWidgetRow.vue?vue&type=template&id=c503e932&"
import script from "./PortfolioWidgetRow.vue?vue&type=script&lang=js&"
export * from "./PortfolioWidgetRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports